<template>
    <div class="brandList">
        
        <div class="list">
            <div v-for="product in preloaded.products" class="listItem"
                 v-if="product.collection === $route.query.collection"
                 @click="goToProduct(product.id)"
            >
                <div class="listIContainer">
                    <div class="imgBox">
                        <img :src="product.image ? product.image : getStaticImage('logo.png')" alt="">
                    </div>
                    <div>{{product.title}}</div>
                </div>
            </div>
        </div>
    
    </div>
</template>

<script>

    import {mapState} from "vuex";
    import pageMixin from "../../mixins/page";

    export default {
        name: 'BrandList',
        mixins: [pageMixin],
        methods: {
            goToProduct(id) {
                this.$router.push({name: "products", query: {...this.$route.query, product: id}})
            }
        },
        mounted(){
            if (!this.$route.query.product){
                const collectionName = this.preloaded.collections[this.$route.query.collection].name;
                this.changePageTitle( collectionName + " | Finest Call | ABM Cocktail Pro");
            }
        },
        computed: {
            ...mapState("shared", ["preloaded"])
        }
    }
</script>

